import {
	SERVER_LOCATION,
	SESSION_KWIKAPI_TOKEN,
	SESSION_USER,
} from "../config.js"

export const loginWithKwik = async ({ username, password }) => {
	return fetch(`${SERVER_LOCATION}/auth/token/`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		credentials: "same-origin",
		body: JSON.stringify({
			username: username.toLowerCase(),
			password,
		}),
	})
}

export const persistAuthSession = (data) => {
	const accessToken = data?.access || data?.access_token

	if (accessToken)
		localStorage.setItem(SESSION_KWIKAPI_TOKEN, accessToken)

	if (data?.user)
		localStorage.setItem(SESSION_USER, JSON.stringify(data.user))
}

export const completeKwikLogin = async (data) => {
	const accessToken = data?.access || data?.access_token

	if (!accessToken || !data?.user)
		return {
			ok: false,
			error: "Não foi possível concluir a autenticação.",
		}

	persistAuthSession({ access: accessToken, user: data.user })

	return {
		ok: true,
		user: data.user,
	}
}

export const clearAuthSession = () => {
	localStorage.removeItem(SESSION_KWIKAPI_TOKEN)
	localStorage.removeItem(SESSION_USER)
}

export const isAuthenticated = () => {
	return Boolean(localStorage.getItem(SESSION_KWIKAPI_TOKEN))
}

export const getStoredUser = () => {
	const rawUser = localStorage.getItem(SESSION_USER)

	if (!rawUser)
		return null

	try {
		return JSON.parse(rawUser)
	} catch {
		return null
	}
}

export const updateStoredUser = (user) => {
	if (!user)
		return

	localStorage.setItem(SESSION_USER, JSON.stringify(user))
}

export const getSSOUser = async (token) => {
	return fetch(`${SERVER_LOCATION}/api/users/me/`, {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
			"Authorization": `Bearer ${token}`
		}
	})
}
